"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoxNumber = exports.getHouseNumber = exports.getStreet = exports.getMunicipality = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    municipality: {
        client: 'api/aem/general/autocomplete/be/municipality',
    },
    street: {
        client: 'api/aem/general/autocomplete/be/street',
    },
    houseNumber: {
        client: 'api/aem/general/autocomplete/be/housenumber',
    },
    boxNumber: {
        client: 'api/aem/general/autocomplete/be/boxnumber',
    },
};
const getMunicipality = (_a, _b, _c) => tslib_1.__awaiter(void 0, [_a, _b, _c], void 0, function* ({ servicesEndpoint, isServer }, { query, lang }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.municipality, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            query,
            language: lang,
        },
        signal,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getMunicipality = getMunicipality;
const getStreet = (_a, _b, _c) => tslib_1.__awaiter(void 0, [_a, _b, _c], void 0, function* ({ servicesEndpoint, isServer }, { municipality, postcode, query, lang }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.street, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            query,
            language: lang,
            municipality,
            postcode,
        },
        signal,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getStreet = getStreet;
const getHouseNumber = (_a, _b, _c) => tslib_1.__awaiter(void 0, [_a, _b, _c], void 0, function* ({ servicesEndpoint, isServer }, { municipality, postcode, street, query, lang }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.houseNumber, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            query,
            language: lang,
            municipality,
            postcode,
            street,
        },
        signal,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getHouseNumber = getHouseNumber;
const getBoxNumber = (_a, _b, _c) => tslib_1.__awaiter(void 0, [_a, _b, _c], void 0, function* ({ servicesEndpoint, isServer }, { municipality, postcode, street, houseNumber, query, lang }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.boxNumber, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            query,
            language: lang,
            municipality,
            postcode,
            street,
            housenumber: houseNumber,
        },
        signal,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getBoxNumber = getBoxNumber;
//# sourceMappingURL=postal.api.js.map